import React from 'react';
import { Check } from 'lucide-react';

const PricingPage = ({ setCurrentPage, user }) => {
  const tiers = [
    {
      name: 'Standard',
      price: 'Free',
      icon: '🥉',
      features: [
        'Track up to 50 bets/month',
        'Basic analytics',
        'Access to public tips',
        'Community forum access',
        'Mobile app access'
      ],
      buttonText: 'Get Started',
      buttonStyle: 'border-2 border-gray-300 text-gray-700 hover:bg-gray-50'
    },
    {
      name: 'Gold',
      price: '$19.99',
      period: '/month',
      icon: '🥇',
      popular: true,
      features: [
        'Unlimited bet tracking',
        'Advanced analytics & reports',
        'Priority access to top tipsters',
        'Export data to Excel/CSV',
        'Bankroll management tools',
        'Email alerts for tips',
        'Wellness content library'
      ],
      buttonText: 'Upgrade to Gold',
      buttonStyle: 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white hover:opacity-90'
    },
    {
      name: 'Diamond',
      price: '$49.99',
      period: '/month',
      icon: '💎',
      premium: true,
      features: [
        'Everything in Gold',
        '1-on-1 betting consultation',
        'Exclusive VIP tipster network',
        'Real-time odds comparison',
        'API access for automation',
        'Priority customer support',
        'Monthly strategy webinars',
        'Custom analytics dashboard'
      ],
      buttonText: 'Go Diamond',
      buttonStyle: 'bg-gradient-to-r from-blue-400 to-purple-400 text-white hover:opacity-90'
    }
  ];

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Choose Your Plan</h1>
          <p className="text-xl text-gray-600">Select the perfect plan for your betting journey</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {tiers.map((tier, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg p-8 ${
                tier.popular ? 'ring-2 ring-yellow-400' : ''
              } ${tier.premium ? 'ring-2 ring-blue-400' : ''}`}
            >
              {tier.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-gray-800 px-4 py-1 rounded-full text-sm font-bold">
                  MOST POPULAR
                </div>
              )}
              {tier.premium && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-blue-400 text-white px-4 py-1 rounded-full text-sm font-bold">
                  PREMIUM
                </div>
              )}
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">{tier.icon}</div>
                <h3 className="text-2xl font-bold mb-2">{tier.name}</h3>
                <div className="text-3xl font-bold text-gray-800">
                  {tier.price}
                  {tier.period && <span className="text-lg text-gray-600">{tier.period}</span>}
                </div>
              </div>
              <ul className="space-y-3 mb-8">
                {tier.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <Check className="text-green-500 mr-2 mt-1" size={16} />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => user ? setCurrentPage('tracker') : setCurrentPage('login')}
                className={`w-full py-3 rounded-full font-semibold transition ${tier.buttonStyle}`}
              >
                {tier.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPage;